import React, { useState } from "react";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { VisibilityIcon, VisibilityOffIcon } from "../../data/icons";
import { useNavigate } from "react-router-dom";
import { url } from "../../data/url";

const EmployerSignUpPage = ({ handleServerError, showToast }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const history = useNavigate();
  const [countdown, setCountdown] = useState(5);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    companyName: "",
    jobTitle: "",
    companyWebsite: "",
    userType: "employer",
  });

  const [formErrors, setFormErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    companyName: "",
    jobTitle: "",
    companyWebsite: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setFormErrors({
      ...formErrors,
      [name]: "",
    });
  };

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
    } else if (field === "confirmPassword") {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    handleServerError(""); // Clear any previous server errors
    if (validateForm()) {
      try {
        const response = await fetch(`${url.path}/signup`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        const data = await response.json();

        console.log('Response :', response);

        if (response.ok) {
          console.log("Signup successful:", data.message);
          resetForm();
          showToast(`Account created, redirecting to login in ${countdown} seconds...`);
          
          // Start countdown and redirect after 5 seconds
          const timer = setInterval(() => {
            setCountdown((prevCountdown) => {
              if (prevCountdown === 1) {
                clearInterval(timer);
                history("/signin");
              }
              return prevCountdown - 1;
            });
          }, 1000);
          // You might want to redirect the user or show a success message here
        } else {
          // Handle server-side validation errors or other issues
          handleServerError(data.message || "An error occurred during signup");
        }
      } catch (error) {
        if(error.response && error.response.status === 409) {
          handleServerError('Email already exists, redirect to login');
        }
        else {
        console.error("Error during signup:", error);
        handleServerError("An error occurred. Please try again later.");
        }
      }
    } else {
      console.log("Form contains errors. Cannot submit.");
    }
  };

  const validateForm = () => {
    let valid = true;
    const errors = {};

    if (formData.firstName.trim() === "") {
      errors.firstName = "First Name is required";
      valid = false;
    }
    if (formData.lastName.trim() === "") {
      errors.lastName = "Last Name is required";
      valid = false;
    }
    if (!formData.email.includes("@")) {
      errors.email = "Invalid email format";
      valid = false;
    }
    if (formData.phoneNumber.trim()  === "") {
      errors.phoneNumber = 'Phone Number is required';
      valid = false;
    }
    if (formData.password.length < 8) {
      errors.password = "Password must be at least 8 characters long";
      valid = false;
    }
    if (formData.confirmPassword !== formData.password) {
      errors.confirmPassword = "Passwords do not match";
      valid = false;
    }
    if (formData.companyName.trim() === "") {
      errors.companyName = "Company Name is required";
      valid = false;
    }
    if (formData.jobTitle.trim() === "") {
      errors.jobTitle = "Job Title is required";
      valid = false;
    }
    if (formData.companyWebsite.trim() === "") {
      errors.companyWebsite = "Company Website is required";
      valid = false;
    }

    setFormErrors(errors);
    return valid;
  };

  const resetForm = () => {
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      password: "",
      confirmPassword: "",
      companyName: "",
      jobTitle: "",
      companyWebsite: "",
      userType: "employer",
    });
    setFormErrors({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      password: "",
      confirmPassword: "",
      companyName: "",
      jobTitle: "",
      companyWebsite: "",
    });
  };

  return (
      <form onSubmit={handleSubmit}>
        <div className="input-group">
          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleInputChange}
            required
          />
          {formErrors.firstName && (
            <span className="error">{formErrors.firstName}</span>
          )}
          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleInputChange}
            required
          />
          {formErrors.lastName && (
            <span className="error">{formErrors.lastName}</span>
          )}
        </div>
        <div className="input-group">
        <div className="phone-input-container">
          <PhoneInput
            international
            defaultCountry="US"
            value={formData.phoneNumber}
            onChange={(phone) => setFormData({ ...formData, phoneNumber: phone })}
            placeholder="Phone Number"
            />
          </div>
          {formErrors.phoneNumber && <span className="error">{formErrors.phoneNumber}</span>}
            <div className="official-email-inp">
          <input
            type="email"
            name="email"
            placeholder="Official Email Id"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
          {formErrors.email && (
            <span className="error">{formErrors.email}</span>
          )}
          </div>
        </div>
        <div className="input-group">
          <div className="password-group">
            <div className="password-group-container">
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleInputChange}
                required
              />
              <span
                className="visibility-icon"
                onClick={() => togglePasswordVisibility("password")}
              >
                {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </span>
            </div>
            {formErrors.password && (
              <span className="error">{formErrors.password}</span>
            )}
          </div>
          <div className="password-group">
            <div className="password-group-container">
              <input
                type={showConfirmPassword ? "text" : "password"}
                id="confirmPassword"
                name="confirmPassword"
                placeholder="Confirm Password"
                value={formData.confirmPassword}
                onChange={handleInputChange}
                required
              />
              <span
                className="visibility-icon"
                onClick={() => togglePasswordVisibility("confirmPassword")}
              >
                {showConfirmPassword ? (
                  <VisibilityOffIcon />
                ) : (
                  <VisibilityIcon />
                )}
              </span>
            </div>
            {formErrors.confirmPassword && (
              <span className="error">{formErrors.confirmPassword}</span>
            )}
          </div>
        </div>
        <div className="input-group">
          <input
            type="text"
            name="companyName"
            placeholder="Company Name"
            value={formData.companyName}
            onChange={handleInputChange}
            required
          />
          {formErrors.companyName && (
            <span className="error">{formErrors.companyName}</span>
          )}
          <input
            type="text"
            name="jobTitle"
            placeholder="Official Job Title"
            value={formData.jobTitle}
            onChange={handleInputChange}
            required
          />
          {formErrors.jobTitle && (
            <span className="error">{formErrors.jobTitle}</span>
          )}
        </div>
        <div className="input-group">
          <input
            type="url"
            name="companyWebsite"
            placeholder="Company Website"
            value={formData.companyWebsite}
            onChange={handleInputChange}
            required
          />
          {formErrors.companyWebsite && (
            <span className="error">{formErrors.companyWebsite}</span>
          )}
        </div>
        <button type="submit">Sign Up</button>
      </form>
  );
};

export default EmployerSignUpPage;
